import AxiosConfig from '@/config/axios-config'

export const FaculdadeAPI = {

  listar () {
    return AxiosConfig.jalekoAPI().get('/admin/faculdades').then(response => response.data)
  }

}

export default FaculdadeAPI
